import { Flex } from "@chakra-ui/react";

import { Logo } from "../logo";

export default function LogoPulse() {
  return (
    <Flex
      w="100vw"
      h="100vh"
      justify="center"
      align="center"
      data-role="spinner"
      animation="pulse 1.5s ease-in-out infinite"
    >
      <Logo />
    </Flex>
  );
}
